import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Collapse, Expand } from '@fluentsms/agentnet-web-icons';
import { Divider, IconButton, makeStyles, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { navMaxWidth, transitionSpeed } from '../../../theme';
const useStyles = makeStyles((theme) => ({
    toggleContainer: {
        marginTop: 'auto',
    },
    toggleNavBtn: {
        color: '#424242',
        flex: `0 0 ${navMaxWidth}px`,
        justifyContent: 'normal',
        padding: theme.spacing(1.5, 2),
        transition: `padding ${transitionSpeed} ease-out`,
        width: navMaxWidth,
        '&:hover, &:focus': {
            backgroundColor: 'transparent',
        },
        '& .MuiIconButton-label': {
            width: 'auto',
        },
    },
    toggleNavBtnCollapsed: {
        padding: theme.spacing(1.5, 3),
    },
    toggleNavBtnText: {
        fontWeight: 500,
        marginLeft: theme.spacing(1),
        transition: `opacity ${transitionSpeed} ease-out`,
    },
    toggleNavBtnTextCollapsed: {
        opacity: 0,
    },
}));
/**
 * Toggle button component for the left navigation menu. Controls whether or not the left navigation panel toggles.
 *
 * @param {boolean} props.isMenuOpen - Indicates whether the left navigation is open or not.
 * @param {Function} props.onClick - The click event handler for the button.
 * @returns {JSX.Element} The rendered `ToggleButton` component.
 */
export function ToggleButton({ isMenuOpen, onClick }) {
    const classes = useStyles();
    const theme = useTheme();
    const mediumScreenAndUp = useMediaQuery(theme.breakpoints.up('sm'));
    return (_jsx("div", { className: classes.toggleContainer, children: mediumScreenAndUp && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsxs(IconButton, { className: clsx(classes.toggleNavBtn, { [classes.toggleNavBtnCollapsed]: !isMenuOpen }), "data-testid": `toggle-menu-${isMenuOpen ? 'open' : 'closed'}`, disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, id: 'nav-collapse', onClick: onClick, children: [isMenuOpen ? (_jsx(Collapse, { fill: '#9e9e9e', height: 24, width: 24, "data-testid": 'leftnav-collapse-button' })) : (_jsx(Expand, { fill: '#9e9e9e', height: 24, width: 24, "data-testid": 'leftnav-expand-button' })), _jsx(Typography, { className: clsx(classes.toggleNavBtnText, { [classes.toggleNavBtnTextCollapsed]: !isMenuOpen }), variant: 'body1', children: "Collapse Nav" })] })] })) }));
}
